<template>
	<div class="llogin">
		<div class="zzhao" @click.stop="closelogin"></div>
		<div class="login">
			<div class="from padding">
				<p class="title text-333 text-bold text-left margin-bottom margin-top-sm">登录/注册</p>
				<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px"
					class="demo-ruleForm">
					<el-form-item label="" prop="modeil" class="solid-bottom">
						<img class="phone" src="../assets/img/phone.png">
						<el-input type="text" v-model="ruleForm.modeil" autocomplete="off" placeholder="请输入手机号">
						</el-input>
					</el-form-item>
					<el-form-item label="" prop="code" class="solid-bottom" v-if="type != 1">
						<img class="phone" src="../assets/img/code.png">
						<el-input type="text" v-model="ruleForm.code" autocomplete="off"
							placeholder="请输入验证码"></el-input>
						<p class="get-btn text-right" @click="getsoce">{{ beginning ? time + "s后重新获取" : "获取" }}</p>
					</el-form-item>
					<el-form-item label="" prop="code" class="solid-bottom" v-if="type != 2">
						<img class="phone" src="../assets/img/code.png">
						<el-input type="text" v-model="ruleForm.pass" autocomplete="off"
							placeholder="请输入密码"></el-input>
					</el-form-item>
					<el-form-item label="" prop="code" class="">
						<div class="flex justify-between" style="width:100%;">
							<div class="pointer" v-if="type != 2" @click="chose(2)">验证码登录</div>
							<div class="pointer" v-if="type != 1" @click="chose(1)">密码登录</div>
							<div class="pointer" v-if="type != 3" @click="chose(3)">注册</div>
						</div>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" class="text-white margin-top" @click.stop="submitForm('ruleForm')">{{type != 3?'登录':'注册'}}</el-button>
						<!-- <el-button v-if="type == 3" type="primary" class="text-white margin-top" @click.stop="submitForm('ruleForm')">注册</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入手机号'));
				} else if (!/^1[3-9]\d{9}$/.test(value)) {
					callback('请输入正确手机号');
				} else {
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入验证码'));
				} else {
					callback();
				}
			};
			var validatePass3 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					callback();
				}
			};
			return {
				ruleForm: {
					modeil: '', //手机号
					code: '', //验证码
					pass:'',//密码
				},
				type:1,// 1 密码登录  2 验证码登录 3  注册
				beginning: false, // 显示倒计时,@Boolean
				time: 60, // 倒计时60S,@Number
				timer: null, // 计时器,@Function
				stat:1,//1=注册 2登录
				rules: {
					modeil: [{
						validator: validatePass,
						trigger: 'blur'
					}],
					// code: [{
					// 	validator: validatePass2,
					// 	trigger: 'blur'
					// }],
					pass:[{
						validator: validatePass3,
						trigger: 'blur'
					}]
				}
			};
		},
		methods: {
			//登录
			submitForm(formName) {
				let type = this.type
				this.$refs[formName].validate((valid) => {
					if (valid) {
						
						if(type == 3){
							this.regst()
						}else if(type == 2){
							this.login()
						}else{
							this.loginpass()
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			chose(type){
				this.type = type
				if(type == 3){
					this.stat = 1
				}else if(type == 2){
					this.stat = 2
				}
			},
			
			/**
			 * 获取验证码
			 * */
			getsoce(){
				let _this = this;
				// 如果有倒计时，return false
				if (this.beginning) return false;
				this.beginning = true; // 显示倒计时
				this.ajax('get', '/api/pc/user/getPhoneCode', {
					phone: this.ruleForm.modeil,
					stat:this.stat,
				}, res => {
					if (res.status == 200) {
						// 清除倒计时,防抖作用
						clearInterval(_this.timer);
						_this.timer = setInterval(() => {
						  if (_this.time == 1) {
						    //倒计时结束就清楚这个倒计时
						    clearInterval(_this.timer);
						    _this.time = 60; // 倒计时60s
						    _this.beginning = false; // 是否显示倒计时改为false
						    return;
						  }
						  _this.time--;
						}, 1000);
					} else {
						_this.beginning = false; // 是否显示倒计时改为false
					}
				})
			},
			/**
			 * 手机号密码登录
			 * */
			loginpass(){
				this.ajax('get', '/api/pc/user/login', {
					phone: this.ruleForm.modeil,
					password:  this.ruleForm.pass
				}, res => {
					console.log(res);
					if (res.status == 200) {
						if(res.data.code == 200){
							let token = res.data.data.token
							localStorage.setItem('user_token', token);
							this.closelogin()
							this.$store.commit('updateUserInfo', res.data.data);
						}else{
							this.$message.error(res.data.msg);
						}
					} else {
						
					}
				})
			},
			/**
			 * 验证码登录
			 * */
			login(){
				this.ajax('post', '/api/pc/user/phoneLogin', {
					phone: this.ruleForm.modeil,
					phone_code:  this.ruleForm.code
				}, res => {
					if (res.status == 200) {
						let token = res.data.data.token
						localStorage.setItem('user_token', token);
						this.closelogin()
						this.$store.commit('updateUserInfo', res.data.data);
					} else {
						// this.$message.error(res.msg);
					}
				})
			},
			/**
			 * 注册
			 * */
			regst(){
				this.ajax('post', '/api/pc/user/register', {
					phone: this.ruleForm.modeil,
					phone_code:  this.ruleForm.code,
					password:  this.ruleForm.pass,
					lng:116.436097,
					lat:39.894238,
				}, res => {
					if (res.status == 200) {
						let token = res.data.data.token
						localStorage.setItem('user_token', token);
						this.closelogin()
						this.$store.commit('updateUserInfo', res.data.data);
					} else {
						// this.$message.error(res.msg);
					}
				})
			},
			//点击关闭登录页面
			closelogin(){
				Bus.$emit('showlogon')
				// this.$emit('closepop')
			}
		}
	}
</script>

<style scoped>
	/deep/ .el-overlay.is-message-box .el-overlay-message-box {
		z-index: 9999;
	}
	.phone {
		width: 17px;
		height: 22px;
	}

	.llogin {
		position: fixed;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		/* background: rgba(0, 0, 0, 0.6600); */
		z-index: 999;
	}
	.zzhao{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.6600);
		z-index: 9;
	}

	.login {
		background: url(../assets/img/login-bg.png);
		width: 1071px;
		height: 709px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 10;
	}

	.title {
		font-size: 28px
	}

	.from {
		width: 444px;
		height: 476px;
		background: #FFFFFF;
		border-radius: 30px;
		position: absolute;
		top: 50%;
		left: 60px;

		transform: translateY(-50%);
	}
	
	.get-btn{
		cursor: pointer;
		color: #09827B;
		min-width: 100px;
	}
	
	.el-button{
		width: 331px;
		height: 51px;
		background: #09827B;
		border: 1px solid #09827B;
		border-radius: 26px;
		margin: 30px auto;;
	}

	/deep/ .el-form-item__content {
		margin-left: 0 !important;
		display: flex;
		align-items: center;
	}

	/deep/ .el-input__inner {
		border: 0 !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/login.vue